import { SeoMeta } from "@/utils/seo/SeoMeta";
import * as P from "@components/customizing/print/Print.styles";
import Layout from "@components/layout/Layout";
import { PrintDesignService } from "@components/customizing/print/PrintDesignService";
import { PrintTab } from "@components/customizing/print/printTab/PrintTab";
import { GuideMemo } from "@components/customizing/print/Print.styles";
import { useRouter } from "next/router";

const PrictGuidePage = () => {
  const router = useRouter();
  return (
    <Layout
      parent={"홈"}
      sub={"소량인쇄"}
      subTitle={"가이드"}
      pageTitle={SeoMeta.smallPrintServiceGuide.title}
      pageDesc={SeoMeta.smallPrintServiceGuide.description}
      pageKeyword={SeoMeta.smallPrintServiceGuide.keywords}
    >
      <PrintTab />
      <P.DesignGuide className="container" id="guide">
        <div className="d-flex flex-column mb-50 pb-80 border-bottom">
          <P.NormalTitle>
            <strong>친절한 가이드</strong>로 쉽고, 편하게!
          </P.NormalTitle>
          <P.TitleDesc>
            예시 사이즈(450mm x 580mm + 40mm)와{" "}
            <strong className="">동일한 규칙</strong>으로
            <strong className="ms-1">다른 사이즈에도 적용</strong>
            되니 참고해 주세요.
          </P.TitleDesc>
          <P.ImgGuideWrapper className="mt-30 mb-30">
            <img src="/assets/imgs/print/design_guide/디자인 사이드 1.png" />
            <div className="description">
              <span className="title">
                앞면 작업 영역 (450mm x 580mm + 40mm)
              </span>
              <span className="desc mb-50">
                기본으로 인쇄되어 있는 환경인증마크와 문구영역과 40mm영역을
                제외한 영역에 인쇄가능합니다.
              </span>
              <span className="title">뒷면 작업 영역 (450mm x 580mm) </span>
              <span className="desc mb-50">
                40mm 영역을 제외한 모든 영역에 인쇄가능합니다.
              </span>
              <span className="danger">
                <i className="fi-rs-exclamation" />
                제공된 칼선도안은 실측 사이즈로 측정돼있으니 수정하지
                말아주세요.
              </span>
            </div>
          </P.ImgGuideWrapper>
          <P.DesignGuideDownloadWrapper>
            <div className="ment">
              디자인 가이드를 다운로드하여 나만의 디자인을 만들어 보세요.
            </div>
            <a
              href="https://file.caretbio.com/caretbio/de351537c92219ad103539aae4341d6b.zip"
              target="__blank"
              className="downloadBtn"
            >
              AI <i className="fi-rs-download" />
            </a>
          </P.DesignGuideDownloadWrapper>
          <P.GuideMemo>
            EL606, EL727 외 다른 기성품의 칼선 가이드는&nbsp;
            <strong>견적요청 후 채널톡</strong>에서 별도로 받아보실 수 있습니다.
          </P.GuideMemo>
        </div>
        <div className="d-flex flex-column mb-50 pb-80 border-bottom">
          <P.NumberUnderBarTitle>01</P.NumberUnderBarTitle>
          <P.MediumTitle>작업물 윤곽처리</P.MediumTitle>
          <P.ImgGridWrapper length={2}>
            <P.ImgBox>
              <img src="/assets/imgs/print/design_guide/디자인_가이드_1-1.jpg" />
              <span>
                텍스트나 도형으로 제작한 작업물은{" "}
                <strong>{`Type > Create Outlines [Shift+Ctrl+O]`}</strong>를
                사용하여 윤곽처리해 주세요.
              </span>
            </P.ImgBox>
            <P.ImgBox>
              <img src="/assets/imgs/print/design_guide/디자인_가이드_1-2.jpg" />
              <span>
                펜툴을 사용한 라인형태의 작업물은{" "}
                <strong>{`Object > Path > Outline Stroke`}</strong>을 사용하여
                윤곽처리해 주세요.
              </span>
            </P.ImgBox>
          </P.ImgGridWrapper>
        </div>
        <div className="d-flex flex-column mb-50 pb-80">
          <P.NumberUnderBarTitle>02</P.NumberUnderBarTitle>
          <P.MediumTitle>레이어 기능 사용</P.MediumTitle>
          <P.ImgGridWrapper length={2}>
            <P.ImgBox>
              <img src="/assets/imgs/print/design_guide/디자인_가이드_2-1.jpg" />
              <span>
                <strong>'디자인'</strong> 레이어를 선택하고 디자인이 완료된
                작업물을 배치해 주세요.
              </span>
            </P.ImgBox>
            <P.ImgBox>
              <img src="/assets/imgs/print/design_guide/디자인_가이드_2-2.jpg" />
              <span>
                레이어 순서는 가이드 파일 그대로 변경없이 작업해야 하며,{" "}
                <strong>레이어명 변경 및 레이어 추가도 불가</strong>
                합니다.
              </span>
            </P.ImgBox>
          </P.ImgGridWrapper>
        </div>

        <P.DesignGuide
          id="essential"
          style={{
            borderTop: "1px solid #dee2e6",
          }}
        >
          <div className="container mt-50 mb-50">
            <div className="d-flex flex-column">
              <P.NormalTitle>
                <strong>디자인 제작요청 사항</strong> 필수기재!
              </P.NormalTitle>
              <P.ImgGridWrapper length={2}>
                <P.ImgBox>
                  <img src="/assets/imgs/print/design_guide/디자인_필수사항1.png" />
                  <span>
                    화이트 / 블랙 이외에 컬러는 <strong>팬톤컬러를 기재</strong>
                    해 주세요.
                  </span>
                </P.ImgBox>
                <P.ImgBox>
                  <img src="/assets/imgs/print/design_guide/디자인_필수사항2.png" />
                  <span>
                    택배봉투의 밑단부터 작업하신 작업물 밑단까지{" "}
                    <strong>mm로 측정하여 기재</strong>해 주세요.
                  </span>
                </P.ImgBox>
              </P.ImgGridWrapper>
            </div>
          </div>
        </P.DesignGuide>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "60px",
          }}
        >
          <P.OutlineBtn
            className="btn"
            onClick={() => router.push("/customizing/print/product/")}
          >
            소량인쇄 상품 선택하기
          </P.OutlineBtn>
        </div>
      </P.DesignGuide>
      <PrintDesignService />
    </Layout>
  );
};
export default PrictGuidePage;
